<template>
    <div class="fpc-nav-container">
        <ul>
            <li v-for="(slide, index) in slidesItems" @mouseenter="hoverItem(index)" @mouseleave="leaveItem(index)">
                <a :href="'#'+slide.anchor"
                   :class="{active: activeSlideIndex===index, hover: activeHoverSlideIndex===index&&itemHoveredOk===true}">
                    <span class="fp-sr-only" v-html="slide.name"></span>
                    <span></span>
                </a>
                <transition name="fadeFP">
                    <div class="fpc-tooltip" v-html="slide.name" v-if="checkShowTooltip(index)"
                         @click="goToSlide(index)"></div>
                </transition>
            </li>
        </ul>
    </div>
</template>


<script>
    import $ from "jquery";
    import fullpage from "fullpage.js/dist/fullpage.extensions.min";
    import {debounce} from "lodash"

    export default {
        props: {},
        data() {
            return {
                fullPageInstance: null,
                slidesItems: [],
                activeSlideIndex: 0,
                showToolTip: false,
                activeHoverSlideIndex: 0,
                itemHovered: false,
                itemHoveredOk: false
            };
        },
        methods: {
            initFullPageJs() {

                this.fullPageInstance = new fullpage("#fullpage", {
                    licenseKey: "48969007-9C374222-92BE1668-FA40EAB3",
                    navigation: false,
                    // sectionsColor:['#ff5f45', '#0798ec', '#fc6c7c', 'grey'],
                    // navigationTooltips: ["firstSlide", "actualités", "3", "4"],
                    // showActiveTooltip: true,
                    verticalCentered: false,
                    scrollingSpeed: 500,
                    scrollBar: true,
                    fixedElements: "#header, #footer",
                    normalScrollElements: ".wrap-level-1",
                    responsiveSlides: true,
                    responsiveWidth: 992,
                    // lockAnchors: true,
                    touchSensitivity: 15,
                    recordHistory: false,
                    onLeave: (origin, destination, direction) => {
                        if (origin.index === 0) {
                            this.$root.showMarianne = false
                        }
                        if (destination.index === 0) {
                            this.$root.showMarianne = true
                        }
                        this.showToolTip = false
                        this.activeSlideIndex = destination.index
                        this.showToolTip = true
                        this.hideToolTip()
                        if (destination.anchor === "section4" && this.$root.$refs["home-focus"] !== undefined) {
                            this.$root.$refs["home-focus"].resumePlay()
                        }
                        if (destination.anchor === "section3" && this.$root.$refs["rnn-map"] !== undefined) {
                            this.$root.$refs["rnn-map"].startAnimation()
                        }
                    },
                });



            },
            hideToolTip: debounce(function () {
                if (this.itemHovered === false) {
                    this.showToolTip = false
                }
            }, 3000),
            checkShowTooltip(index) {

                if (this.itemHoveredOk && this.activeHoverSlideIndex === index) {
                    return true
                }

                if (this.itemHoveredOk === false && (this.activeSlideIndex === index && this.showToolTip === true)) {
                    return true
                } else {
                    return false
                }
            },
            hoverItem(index) {
                this.itemHovered = true
                this.itemHoveredOk = true
                this.showToolTip = true
                this.activeHoverSlideIndex = index

            },
            leaveItem(index) {
                this.itemHovered = false
                this.leaveItemDebounce()
            },
            leaveItemDebounce: debounce(function () {
                if (this.itemHovered === false) {
                    this.hideToolTip()
                    this.itemHoveredOk = false
                }
            }, 1000),
            goToSlide(index) {
                // this.itemHoveredOk = false

                this.fullPageInstance.moveTo(index + 1, 0);
            },
            initScrollDown() {

                $(".scroll-to-bottom").on("click", (event) => {
                    event.preventDefault()
                    this.fullPageInstance.moveSectionDown();
                })

            },
            disableScroll() {
                this.fullPageInstance.setAllowScrolling(false);
                this.fullPageInstance.setKeyboardScrolling(false);
                // this.fullPageInstance.destroy('all')
            },
            enableScroll() {
                this.fullPageInstance.setAllowScrolling(true);
                this.fullPageInstance.setKeyboardScrolling(true);
                // this.initFullPageJs()

            }
        },
        created() {

            $("#fullpage .section").each((index, item) => {
                this.slidesItems.push({
                    "anchor": $(item).data("anchor"),
                    "name": $(item).data("name"),
                })
            })

        },
        mounted() {
            this.initFullPageJs()
            this.initScrollDown()
        },
        destroyed() {
        }
    };
</script>
